import { ISize } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ISizePropertyEditable {
  size(): IPropertyEditable<ISize>;
}

export function instanceOfISizePropertyEditable(instance: any): instance is ISizePropertyEditable {
  return instance
      && instance.size
      && instanceOfIPropertyEditable<ISize>(instance.size());
}
